// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipc {
    position: relative;
    display: inline-block;
}

.tooltipc .tooltiptextc {
    font-weight: 400;
    line-height: 1.5;
    visibility: hidden;
    width: 200px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 10px;
    position: absolute;
    z-index: 1;
    top: 100%;
    left: 50%;
    margin-left: -100px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: .875rem;
}

.tooltipc .tooltiptextc::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #000 transparent;
}

.tooltipc:hover .tooltiptextc {
    visibility: visible;
    opacity: 1;
    color: #fff;
}

@media (min-width: 1400px) {
    #cplp_pricing-table.container {
        max-width: 1320px;
    }
}

.cl-cursor-not-allowed {
    cursor: not-allowed;
    background-color: rgb(220 220 220 / 1) !important;
    color: rgb(114 113 114/1);
    border: 2px solid rgb(220 220 220 / 1) !important;
}

.cl-cursor-not-allowed:hover {
    color: white !important;
    transform: unset !important;
}

.cl-flex {
    display: flex;
}

.cl-mr-2 {
    margin-right: .5rem;
}

.cl-ml-3 {
    margin-left: .75rem;
}

.cl-py-2 {
    padding-top: .5rem;
    padding-bottom: .5rem;
}

.cl-px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}

.cl-cursor-pointer {
    cursor: pointer;
}

.cl-flex-col {
    flex-direction: column;
}

.gap-5 {
    gap: 5px;
}

.label-extra-small {
    font-size: 10px;
    line-height: 10px;
}

.label-extra-small,
.label-small {
    font-family: Inter, sans-serif;
    font-weight: 500;
    word-wrap: break-word;
}

.label-small {
    min-height: 20px;
}

.cl-text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.cl-py-1 {
    padding-top: .25rem;
    padding-bottom: .25rem;
}

.cl-px-2 {
    padding-left: .5rem;
    padding-right: .5rem;
}

.cl-bg-g0-dark-green-500 {
    --tw-bg-opacity: 1;
    background-color: #2c77e8;
}

.label-medium {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
}

.body-caption,
.label-medium {
    font-family: Inter, sans-serif;
    letter-spacing: .3px;
    word-wrap: break-word;
}

.cl-py-3 {
    padding-top: .75rem;
    padding-bottom: .75rem;
}

.cl-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.cl-border-g0-secondary {
    --tw-border-opacity: 1;
    border-color: #2c77e8;
    background-color: #2c77e8;
}

.cl-border {
    border-width: 1px;
}

.\\!cl-rounded-\\[10px\\] {
    border-radius: 10px !important;
}

.cl-gap-2 {
    gap: .5rem;
}

.hover\\:cl-bg-g0-gray-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(220 220 220 / 1);
}

.body-medium,
.title-medium {
    line-height: 24px;
    letter-spacing: .3px;
    word-wrap: break-word;
}

.title-medium {
    font-size: 16px;
    font-weight: 500;
}

.cl-text-\\[\\#777\\] {
    --tw-text-opacity: 1;
    color: rgb(119 119 119 / 1);
    min-height: 39px;
    line-height: 1.5;
}

.price-section {
    display: flex;
    flex-direction: column;
    gap: .5rem;
}

.body-large,
.title-large {
    font-family: Inter, sans-serif;
    line-height: 28px;
    letter-spacing: .2px;
    word-wrap: break-word;
}

.title-large {
    font-size: 24px;
    font-weight: 500;
}

.body-small {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
}

.body-small,
.title-small {
    font-family: Inter, sans-serif;
    line-height: 20px;
    letter-spacing: .3px;
    word-wrap: break-word;
}

.cl-backdrop-blur-\\[16px\\],
.cl-backdrop-blur-lg {
    --tw-backdrop-blur: blur(16px);
}

.cl-shadow-depth1 {
    --tw-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, .2), 0px 1px 4px -1px rgba(0, 0, 0, .2);
    --tw-shadow-colored: 0px 0px 1.5px 0px var(--tw-shadow-color), 0px 1px 4px -1px var(--tw-shadow-color);
}

.cl-shadow,
.cl-shadow-depth1 {
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.cl-p-\\[6px\\] {
    padding: 6px;
}

.cl-bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.cl-rounded-\\[6px\\] {
    border-radius: 6px;
}

.cl-w-fit {
    width: fit-content;
}

.cl-bg-black\\/5 {
    background-color: #0000000d;
}


.cl-visible {
    min-height: 20px;
}

.cl-text-g0-dark-green-500 {
    --tw-text-opacity: 1;
    color: #2c77e8;
}

.cl-ml-2 {
    margin-left: .5rem;
}

.cl-ml-1 {
    margin-left: .25rem;
}

.cl-py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.cl-text-center {
    text-align: center;
}

.cl-border-y-\\[\\#D9D9D9\\],
.cl-border-y-\\[\\#d9d9d9\\] {
    --tw-border-opacity: 1;
    border-top-color: rgb(217 217 217 / 1);
    border-top-style: solid;
    border-bottom-color: rgb(217 217 217 / 1);
    border-bottom-style: solid;
}

.cl-border-y-\\[1px\\] {
    border-bottom-width: 1px;
    border-top-width: 1px;
}

.cl-border-b,
.cl-border-y-\\[1px\\] {
    border-bottom-width: 1px;
}

.cl-border-bottom {
    border-bottom: 1px solid;
    border-color: rgb(220 220 220 / 1);
}

.cl-w-full {
    width: 100%;
}

.cl-gap-\\[13px\\] {
    gap: 13px;
}



.cl-gap-3 {
    gap: .75rem;
}

.cl-items-center {
    align-items: center;
}

.cl-rounded-full {
    border-radius: 9999px;
}

.cl-justify-center {
    justify-content: center;
}

.cl-flex-1 {
    flex: 1 1 0%;
}

.cl-p-6 {
    padding: 1.5rem;
}

.cl-bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / 1);
}

.cl-rounded-\\[8px\\] {
    border-radius: 8px;
}

.cl-rounded-\\[12px\\] {
    border-radius: 12px;
}

.cl-gap-\\[15px\\] {
    gap: 15px;
}

.cl-gap-\\[28px\\] {
    gap: 28px;
}

.most-popular {
    border-width: 1px !important;
    border-color: #2c77e8 !important;
    border-style: solid !important;
}

.pricing1 .most-popular {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 48px -16px !important;
}

@media (min-width: 1024px) {
    .lg\\:cl-gap-\\[18px\\] {
        gap: 18px;
    }
}

@media (min-width: 768px) {
    .md\\:cl-gap-2 {
        gap: .5rem;
    }
}

.cl-content-center {
    align-content: center;
}

.cl-text-g0-secondary {
    --tw-text-opacity: 1;
    color: rgb(114 113 114 / 1);
}


.cl-border-g0-gray-100 {
    --tw-border-opacity: 1;
    border-color: rgb(220 220 220 / 1);
    border: 1px solid;
}

.cl-border-b-0 {
    border-bottom-width: 0;
}

.cl-rounded-t-\\[16px\\] {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    border-color: rgb(220 220 220 / 1);
}

.cl-rounded-t-\\[16px\\].most-popular {
    border-left: 1px solid #2c77e8 !important;
    border-right: 1px solid #2c77e8 !important;
    border-top: 1px solid #2c77e8 !important;
    border-bottom: 0 !important;
    box-shadow: none !important;
}

.cl-border-x-\\[1px\\] {
    border-left: 1px solid;
    border-right: 1px solid;
    border-color: rgb(220 220 220 / 1);
}

.cl-border-x-\\[1px\\].most-popular {
    border-left: 1px solid #2c77e8 !important;
    border-right: 1px solid #2c77e8 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
    /* box-shadow: none !important; */
}

.cl-border-x-\\[1px\\].most-popular.bottom-border-green {
    border-bottom: 1px solid #2c77e8 !important;
}

.lg\\:cl-pt-5 {
    padding-top: 1.25rem;
}

.hidden {
    visibility: hidden;
}

.d-none {
    display: none !important;
}

.caption {
    font-size: 13px;
    text-align: left;
}

#main-filter {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    flex-wrap: wrap;
    /* allows reordering without breaking layout */
    gap: 15px;
}

.drp-currnecy {
    display: flex;
    gap: 5px;
}

/* Desktop/Web layout */
@media (min-width: 992px) {
    #main-filter>.drp-currnecy:first-child {
        order: 1;
    }

    /* Currency dropdown */
    #main-filter>.cl-flex {
        order: 2;
    }

    /* Annual/Monthly tab */
    #main-filter>div:last-child {
        order: 3;
    }
}

/* Mobile layout */
@media (max-width: 991px) {
    #main-filter {
        flex-direction: row;
        align-items: stretch;
    }

    /* Make the second element (toggle) come first and occupy full width */
    #main-filter> :nth-child(2) {
        order: 1;
        flex: 0 0 100%;
        width: 100% !important;
        /* override inline / other width */
        box-sizing: border-box;
        display: flex;
        /* keep your inner layout centered */
        justify-content: center;
    }

    /* Make first and third elements share the next row, each ~50% */
    #main-filter> :nth-child(1),
    #main-filter> :nth-child(3) {
        order: 2;
        flex: 0 0 calc(50% - 7.5px);
        /* account for gap (half of gap) */
        width: calc(50% - 7.5px) !important;
        /* override inline width:220px */
        box-sizing: border-box;
    }

    #main-filter> :nth-child(3) {
        text-align: right;
    }

    /* keep the number input compact inside its half */
    #main-filter> :nth-child(3) input {
        max-width: 35px;
        width: 100%;
        display: inline-block;
    }

    .overflow-scroll .free-plan {
        display: none;
    }

    .additional-control> :nth-child(2) {
        order: 3 !important;
    }

    .additional-control> :nth-child(3) {
        order: 2 !important;
        flex: 0 0 100% !important;
        width: 100% !important;
        /* override inline / other width */
        box-sizing: border-box;
        display: flex;
        /* keep your inner layout centered */
        justify-content: center !important;
    }

    .additional-control> :nth-child(1),
    .additional-control> :nth-child(4) {
        order: 4 !important;
    }

    .additional-control> :nth-child(4) {
        text-align: right;
    }

    .additional-control> :nth-child(4) input {
        max-width: 80px;
        width: 100%;
        display: inline-block;
    }
}

@media (max-width: 991px) {
    .overflow-scroll {
        overflow-x: scroll;
    }

    .overflow-auto::-webkit-scrollbar {
        display: none;
    }

    .overflow-scroll .col-12 {
        max-width: 85%;
    }

    .PricingHeader_Content {
        min-width: 150px !important;
    }
}

@media (min-width: 768px) {
    .overflow-scroll .col-md-6 {
        max-width: 45%;
    }
}

.cl-rounded-b-\\[16px\\] {
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
}

.cl-shadow-depth2x {
    box-shadow: 0 0 #0000, 0 0 #0000, 0px 0px 1.5px 0px rgba(0, 0, 0, .2), 0px 2px 0px -2px rgba(0, 0, 0, .2) !important;
}

.cplp_btn-action-buy {
    box-shadow: none !important;
}


.compare-plan .title-medium {
    font-size: 10px;
    font-weight: 600;
}

.compare-plan .caption {
    font-size: 10px;
    text-align: left;
}

.accordion {
    width: 100%;
    border-collapse: collapse;
}

.accordion-item {
    border-bottom: 1px solid #ddd;
}

.accordion-header {
    display: flex;
    justify-content: space-between;
    background-color: #2ea1f845 !important;
    padding: 10px 15px;
    font-weight: bold;
    cursor: pointer;
    color: #1a1a1a !important;
}

.accordion-content {
    background: #fff;
    padding: 0 10px 10px;
}

.feature-table {
    width: 100%;
    border-collapse: collapse;
}

.feature-table td {
    padding: 8px;
    text-align: center;
}

.checkmark {
    font-size: 18px;
    color: #1a1a1a !important;
}

.accordion-item .accordion-header .icon {
    color: #1a1a1a !important;
}

.c-border-bottom {
    border-bottom: 3px solid #2ea1f845 !important;
    ;
}

.compare-plan-container {
    display: none;
    flex-direction: column;
    width: 100%;
    overflow-x: auto;
}

.compare-plan {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

.compare-plan .cplp_btn-action {
    padding: 0;
    font-size: 8px;
    margin: 12px 0;
}


@media (max-width: 1024px) {
    .compare-plan-container {
        display: flex;
    }

    .drp-standard-mobile {
        display: block;
    }

    .drp-standard-web {
        display: none !important;
    }
}

.drp-standard-mobile {
    display: none;
}

.drp-standard-web {
    display: block;
}


/* .fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  z-index: 6000;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  padding: 10px 20px;
} */

.bb-unset {
    border-bottom: unset !important;
}

.flicker {
    animation: flickerAnimation 1s linear infinite;
}

@keyframes flickerAnimation {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    25% {
        opacity: 0.3;
        transform: translateY(-2px);
    }

    50% {
        opacity: 1;
        transform: translateY(0);
    }

    75% {
        opacity: 0.3;
        transform: translateY(2px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.PricingHeader_Content {
    display: flex;
    min-width: 200px;
    border-radius: 8px;
    line-height: 20px;
    letter-spacing: .3px;
    word-wrap: break-word;
    --tw-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, .2), 0px 1px 4px -1px rgba(0, 0, 0, .2);
    --tw-shadow-colored: 0px 0px 1.5px 0px var(--tw-shadow-color), 0px 1px 4px -1px var(--tw-shadow-color);
    --tw-backdrop-blur: blur(16px);
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / 1);
    justify-content: space-between;
    text-align: center;
    gap: 24px;
    padding: 12px;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);


    align-items: center;
    gap: 10px;
    /* padding: 8px 12px; */
    /* border-radius: 4px; */
    /* border: 1px solid #ddd; */
    flex-shrink: 0;
}

.PricingHeader_Content span {
    font-size: 13px;
    color: black;
}

.PricingHeader_Content input {
    appearance: none;
    --webkit-appearance: none;
    border: none;
    font-size: 13px;
    font-weight: 600;
}

.PricingHeader_Content input:active,
.PricingHeader_Content input:focus {
    outline: none;

}

.PricingHeader_NumberBtns {
    display: flex;
    align-items: center;
    gap: 8px;
}

.no-arrow::-webkit-inner-spin-button,
.no-arrow::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-arrow[type=number] {
    -moz-appearance: textfield;
    --webkit-appearance: textfield;
}

.PricingHeader_NumberBtns button {
    /* display: flex;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    width: 22px;
    height: 22px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #d3dde2;
    border-radius: 40px; */
    width: 24px;
    height: 24px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/app/main/subscriptions/subscriptionplans.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,iDAAiD;IACjD,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;;IAEI,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,oFAAoF;IACpF,sGAAsG;AAC1G;;AAEA;;IAEI,uGAAuG;AAC3G;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IAEI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,sCAAsC;IACtC,uBAAuB;IACvB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;;AAGA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;IAC1C,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;IAC1C,wBAAwB;IACxB,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,eAAe;IACf,8CAA8C;IAC9C,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA,uBAAuB;AACvB;IACI;QACI,QAAQ;IACZ;;IAEA,sBAAsB;IACtB;QACI,QAAQ;IACZ;;IAEA,uBAAuB;IACvB;QACI,QAAQ;IACZ;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA,sEAAsE;IACtE;QACI,QAAQ;QACR,cAAc;QACd,sBAAsB;QACtB,kCAAkC;QAClC,sBAAsB;QACtB,aAAa;QACb,oCAAoC;QACpC,uBAAuB;IAC3B;;IAEA,gEAAgE;IAChE;;QAEI,QAAQ;QACR,2BAA2B;QAC3B,kCAAkC;QAClC,mCAAmC;QACnC,gCAAgC;QAChC,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA,kDAAkD;IAClD;QACI,eAAe;QACf,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,sBAAsB;QACtB,kCAAkC;QAClC,sBAAsB;QACtB,aAAa;QACb,oCAAoC;QACpC,kCAAkC;IACtC;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,oHAAoH;AACxH;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;;AAEjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,cAAc;AAClB;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;AAGA;;;;;;;;;GASG;;AAEH;IACI,+BAA+B;AACnC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,oFAAoF;IACpF,sGAAsG;IACtG,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,uGAAuG;;;IAGvG,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;AAEjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI;;;;;;;;;;;;0BAYsB;IACtB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB","sourcesContent":[".tooltipc {\n    position: relative;\n    display: inline-block;\n}\n\n.tooltipc .tooltiptextc {\n    font-weight: 400;\n    line-height: 1.5;\n    visibility: hidden;\n    width: 200px;\n    background-color: #000;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 10px;\n    position: absolute;\n    z-index: 1;\n    top: 100%;\n    left: 50%;\n    margin-left: -100px;\n    opacity: 0;\n    transition: opacity 0.3s;\n    font-size: .875rem;\n}\n\n.tooltipc .tooltiptextc::after {\n    content: \"\";\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent #000 transparent;\n}\n\n.tooltipc:hover .tooltiptextc {\n    visibility: visible;\n    opacity: 1;\n    color: #fff;\n}\n\n@media (min-width: 1400px) {\n    #cplp_pricing-table.container {\n        max-width: 1320px;\n    }\n}\n\n.cl-cursor-not-allowed {\n    cursor: not-allowed;\n    background-color: rgb(220 220 220 / 1) !important;\n    color: rgb(114 113 114/1);\n    border: 2px solid rgb(220 220 220 / 1) !important;\n}\n\n.cl-cursor-not-allowed:hover {\n    color: white !important;\n    transform: unset !important;\n}\n\n.cl-flex {\n    display: flex;\n}\n\n.cl-mr-2 {\n    margin-right: .5rem;\n}\n\n.cl-ml-3 {\n    margin-left: .75rem;\n}\n\n.cl-py-2 {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n}\n\n.cl-px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n\n.cl-cursor-pointer {\n    cursor: pointer;\n}\n\n.cl-flex-col {\n    flex-direction: column;\n}\n\n.gap-5 {\n    gap: 5px;\n}\n\n.label-extra-small {\n    font-size: 10px;\n    line-height: 10px;\n}\n\n.label-extra-small,\n.label-small {\n    font-family: Inter, sans-serif;\n    font-weight: 500;\n    word-wrap: break-word;\n}\n\n.label-small {\n    min-height: 20px;\n}\n\n.cl-text-white {\n    --tw-text-opacity: 1;\n    color: rgb(255 255 255 / var(--tw-text-opacity, 1));\n}\n\n.cl-py-1 {\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n}\n\n.cl-px-2 {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n\n.cl-bg-g0-dark-green-500 {\n    --tw-bg-opacity: 1;\n    background-color: #2c77e8;\n}\n\n.label-medium {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n}\n\n.body-caption,\n.label-medium {\n    font-family: Inter, sans-serif;\n    letter-spacing: .3px;\n    word-wrap: break-word;\n}\n\n.cl-py-3 {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n}\n\n.cl-px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n}\n\n.cl-border-g0-secondary {\n    --tw-border-opacity: 1;\n    border-color: #2c77e8;\n    background-color: #2c77e8;\n}\n\n.cl-border {\n    border-width: 1px;\n}\n\n.\\!cl-rounded-\\[10px\\] {\n    border-radius: 10px !important;\n}\n\n.cl-gap-2 {\n    gap: .5rem;\n}\n\n.hover\\:cl-bg-g0-gray-100:hover {\n    --tw-bg-opacity: 1;\n    background-color: rgb(220 220 220 / 1);\n}\n\n.body-medium,\n.title-medium {\n    line-height: 24px;\n    letter-spacing: .3px;\n    word-wrap: break-word;\n}\n\n.title-medium {\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.cl-text-\\[\\#777\\] {\n    --tw-text-opacity: 1;\n    color: rgb(119 119 119 / 1);\n    min-height: 39px;\n    line-height: 1.5;\n}\n\n.price-section {\n    display: flex;\n    flex-direction: column;\n    gap: .5rem;\n}\n\n.body-large,\n.title-large {\n    font-family: Inter, sans-serif;\n    line-height: 28px;\n    letter-spacing: .2px;\n    word-wrap: break-word;\n}\n\n.title-large {\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.body-small {\n    font-size: 12px;\n    font-weight: 400;\n    text-align: left;\n}\n\n.body-small,\n.title-small {\n    font-family: Inter, sans-serif;\n    line-height: 20px;\n    letter-spacing: .3px;\n    word-wrap: break-word;\n}\n\n.cl-backdrop-blur-\\[16px\\],\n.cl-backdrop-blur-lg {\n    --tw-backdrop-blur: blur(16px);\n}\n\n.cl-shadow-depth1 {\n    --tw-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, .2), 0px 1px 4px -1px rgba(0, 0, 0, .2);\n    --tw-shadow-colored: 0px 0px 1.5px 0px var(--tw-shadow-color), 0px 1px 4px -1px var(--tw-shadow-color);\n}\n\n.cl-shadow,\n.cl-shadow-depth1 {\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.cl-p-\\[6px\\] {\n    padding: 6px;\n}\n\n.cl-bg-white {\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));\n}\n\n.cl-rounded-\\[6px\\] {\n    border-radius: 6px;\n}\n\n.cl-w-fit {\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.cl-bg-black\\/5 {\n    background-color: #0000000d;\n}\n\n\n.cl-visible {\n    min-height: 20px;\n}\n\n.cl-text-g0-dark-green-500 {\n    --tw-text-opacity: 1;\n    color: #2c77e8;\n}\n\n.cl-ml-2 {\n    margin-left: .5rem;\n}\n\n.cl-ml-1 {\n    margin-left: .25rem;\n}\n\n.cl-py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n}\n\n.cl-text-center {\n    text-align: center;\n}\n\n.cl-border-y-\\[\\#D9D9D9\\],\n.cl-border-y-\\[\\#d9d9d9\\] {\n    --tw-border-opacity: 1;\n    border-top-color: rgb(217 217 217 / 1);\n    border-top-style: solid;\n    border-bottom-color: rgb(217 217 217 / 1);\n    border-bottom-style: solid;\n}\n\n.cl-border-y-\\[1px\\] {\n    border-bottom-width: 1px;\n    border-top-width: 1px;\n}\n\n.cl-border-b,\n.cl-border-y-\\[1px\\] {\n    border-bottom-width: 1px;\n}\n\n.cl-border-bottom {\n    border-bottom: 1px solid;\n    border-color: rgb(220 220 220 / 1);\n}\n\n.cl-w-full {\n    width: 100%;\n}\n\n.cl-gap-\\[13px\\] {\n    gap: 13px;\n}\n\n\n\n.cl-gap-3 {\n    gap: .75rem;\n}\n\n.cl-items-center {\n    align-items: center;\n}\n\n.cl-rounded-full {\n    border-radius: 9999px;\n}\n\n.cl-justify-center {\n    justify-content: center;\n}\n\n.cl-flex-1 {\n    flex: 1 1 0%;\n}\n\n.cl-p-6 {\n    padding: 1.5rem;\n}\n\n.cl-bg-white {\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / 1);\n}\n\n.cl-rounded-\\[8px\\] {\n    border-radius: 8px;\n}\n\n.cl-rounded-\\[12px\\] {\n    border-radius: 12px;\n}\n\n.cl-gap-\\[15px\\] {\n    gap: 15px;\n}\n\n.cl-gap-\\[28px\\] {\n    gap: 28px;\n}\n\n.most-popular {\n    border-width: 1px !important;\n    border-color: #2c77e8 !important;\n    border-style: solid !important;\n}\n\n.pricing1 .most-popular {\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 48px -16px !important;\n}\n\n@media (min-width: 1024px) {\n    .lg\\:cl-gap-\\[18px\\] {\n        gap: 18px;\n    }\n}\n\n@media (min-width: 768px) {\n    .md\\:cl-gap-2 {\n        gap: .5rem;\n    }\n}\n\n.cl-content-center {\n    align-content: center;\n}\n\n.cl-text-g0-secondary {\n    --tw-text-opacity: 1;\n    color: rgb(114 113 114 / 1);\n}\n\n\n.cl-border-g0-gray-100 {\n    --tw-border-opacity: 1;\n    border-color: rgb(220 220 220 / 1);\n    border: 1px solid;\n}\n\n.cl-border-b-0 {\n    border-bottom-width: 0;\n}\n\n.cl-rounded-t-\\[16px\\] {\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    border-color: rgb(220 220 220 / 1);\n}\n\n.cl-rounded-t-\\[16px\\].most-popular {\n    border-left: 1px solid #2c77e8 !important;\n    border-right: 1px solid #2c77e8 !important;\n    border-top: 1px solid #2c77e8 !important;\n    border-bottom: 0 !important;\n    box-shadow: none !important;\n}\n\n.cl-border-x-\\[1px\\] {\n    border-left: 1px solid;\n    border-right: 1px solid;\n    border-color: rgb(220 220 220 / 1);\n}\n\n.cl-border-x-\\[1px\\].most-popular {\n    border-left: 1px solid #2c77e8 !important;\n    border-right: 1px solid #2c77e8 !important;\n    border-top: 0 !important;\n    border-bottom: 0 !important;\n    /* box-shadow: none !important; */\n}\n\n.cl-border-x-\\[1px\\].most-popular.bottom-border-green {\n    border-bottom: 1px solid #2c77e8 !important;\n}\n\n.lg\\:cl-pt-5 {\n    padding-top: 1.25rem;\n}\n\n.hidden {\n    visibility: hidden;\n}\n\n.d-none {\n    display: none !important;\n}\n\n.caption {\n    font-size: 13px;\n    text-align: left;\n}\n\n#main-filter {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    flex-wrap: wrap;\n    /* allows reordering without breaking layout */\n    gap: 15px;\n}\n\n.drp-currnecy {\n    display: flex;\n    gap: 5px;\n}\n\n/* Desktop/Web layout */\n@media (min-width: 992px) {\n    #main-filter>.drp-currnecy:first-child {\n        order: 1;\n    }\n\n    /* Currency dropdown */\n    #main-filter>.cl-flex {\n        order: 2;\n    }\n\n    /* Annual/Monthly tab */\n    #main-filter>div:last-child {\n        order: 3;\n    }\n}\n\n/* Mobile layout */\n@media (max-width: 991px) {\n    #main-filter {\n        flex-direction: row;\n        align-items: stretch;\n    }\n\n    /* Make the second element (toggle) come first and occupy full width */\n    #main-filter> :nth-child(2) {\n        order: 1;\n        flex: 0 0 100%;\n        width: 100% !important;\n        /* override inline / other width */\n        box-sizing: border-box;\n        display: flex;\n        /* keep your inner layout centered */\n        justify-content: center;\n    }\n\n    /* Make first and third elements share the next row, each ~50% */\n    #main-filter> :nth-child(1),\n    #main-filter> :nth-child(3) {\n        order: 2;\n        flex: 0 0 calc(50% - 7.5px);\n        /* account for gap (half of gap) */\n        width: calc(50% - 7.5px) !important;\n        /* override inline width:220px */\n        box-sizing: border-box;\n    }\n\n    #main-filter> :nth-child(3) {\n        text-align: right;\n    }\n\n    /* keep the number input compact inside its half */\n    #main-filter> :nth-child(3) input {\n        max-width: 35px;\n        width: 100%;\n        display: inline-block;\n    }\n\n    .overflow-scroll .free-plan {\n        display: none;\n    }\n\n    .additional-control> :nth-child(2) {\n        order: 3 !important;\n    }\n\n    .additional-control> :nth-child(3) {\n        order: 2 !important;\n        flex: 0 0 100% !important;\n        width: 100% !important;\n        /* override inline / other width */\n        box-sizing: border-box;\n        display: flex;\n        /* keep your inner layout centered */\n        justify-content: center !important;\n    }\n\n    .additional-control> :nth-child(1),\n    .additional-control> :nth-child(4) {\n        order: 4 !important;\n    }\n\n    .additional-control> :nth-child(4) {\n        text-align: right;\n    }\n\n    .additional-control> :nth-child(4) input {\n        max-width: 80px;\n        width: 100%;\n        display: inline-block;\n    }\n}\n\n@media (max-width: 991px) {\n    .overflow-scroll {\n        overflow-x: scroll;\n    }\n\n    .overflow-auto::-webkit-scrollbar {\n        display: none;\n    }\n\n    .overflow-scroll .col-12 {\n        max-width: 85%;\n    }\n\n    .PricingHeader_Content {\n        min-width: 150px !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .overflow-scroll .col-md-6 {\n        max-width: 45%;\n    }\n}\n\n.cl-rounded-b-\\[16px\\] {\n    border-bottom-right-radius: 16px;\n    border-bottom-left-radius: 16px;\n}\n\n.cl-shadow-depth2x {\n    box-shadow: 0 0 #0000, 0 0 #0000, 0px 0px 1.5px 0px rgba(0, 0, 0, .2), 0px 2px 0px -2px rgba(0, 0, 0, .2) !important;\n}\n\n.cplp_btn-action-buy {\n    box-shadow: none !important;\n}\n\n\n.compare-plan .title-medium {\n    font-size: 10px;\n    font-weight: 600;\n}\n\n.compare-plan .caption {\n    font-size: 10px;\n    text-align: left;\n}\n\n.accordion {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.accordion-item {\n    border-bottom: 1px solid #ddd;\n}\n\n.accordion-header {\n    display: flex;\n    justify-content: space-between;\n    background-color: #2ea1f845 !important;\n    padding: 10px 15px;\n    font-weight: bold;\n    cursor: pointer;\n    color: #1a1a1a !important;\n}\n\n.accordion-content {\n    background: #fff;\n    padding: 0 10px 10px;\n}\n\n.feature-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.feature-table td {\n    padding: 8px;\n    text-align: center;\n}\n\n.checkmark {\n    font-size: 18px;\n    color: #1a1a1a !important;\n}\n\n.accordion-item .accordion-header .icon {\n    color: #1a1a1a !important;\n}\n\n.c-border-bottom {\n    border-bottom: 3px solid #2ea1f845 !important;\n    ;\n}\n\n.compare-plan-container {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    overflow-x: auto;\n}\n\n.compare-plan {\n    display: flex;\n    flex-wrap: wrap;\n    height: 100%;\n}\n\n.compare-plan .cplp_btn-action {\n    padding: 0;\n    font-size: 8px;\n    margin: 12px 0;\n}\n\n\n@media (max-width: 1024px) {\n    .compare-plan-container {\n        display: flex;\n    }\n\n    .drp-standard-mobile {\n        display: block;\n    }\n\n    .drp-standard-web {\n        display: none !important;\n    }\n}\n\n.drp-standard-mobile {\n    display: none;\n}\n\n.drp-standard-web {\n    display: block;\n}\n\n\n/* .fixed-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: white;\n  z-index: 6000;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  padding: 10px 20px;\n} */\n\n.bb-unset {\n    border-bottom: unset !important;\n}\n\n.flicker {\n    animation: flickerAnimation 1s linear infinite;\n}\n\n@keyframes flickerAnimation {\n    0% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n\n    25% {\n        opacity: 0.3;\n        transform: translateY(-2px);\n    }\n\n    50% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n\n    75% {\n        opacity: 0.3;\n        transform: translateY(2px);\n    }\n\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.PricingHeader_Content {\n    display: flex;\n    min-width: 200px;\n    border-radius: 8px;\n    line-height: 20px;\n    letter-spacing: .3px;\n    word-wrap: break-word;\n    --tw-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, .2), 0px 1px 4px -1px rgba(0, 0, 0, .2);\n    --tw-shadow-colored: 0px 0px 1.5px 0px var(--tw-shadow-color), 0px 1px 4px -1px var(--tw-shadow-color);\n    --tw-backdrop-blur: blur(16px);\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / 1);\n    justify-content: space-between;\n    text-align: center;\n    gap: 24px;\n    padding: 12px;\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n\n\n    align-items: center;\n    gap: 10px;\n    /* padding: 8px 12px; */\n    /* border-radius: 4px; */\n    /* border: 1px solid #ddd; */\n    flex-shrink: 0;\n}\n\n.PricingHeader_Content span {\n    font-size: 13px;\n    color: black;\n}\n\n.PricingHeader_Content input {\n    appearance: none;\n    --webkit-appearance: none;\n    border: none;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.PricingHeader_Content input:active,\n.PricingHeader_Content input:focus {\n    outline: none;\n\n}\n\n.PricingHeader_NumberBtns {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.no-arrow::-webkit-inner-spin-button,\n.no-arrow::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.no-arrow[type=number] {\n    -moz-appearance: textfield;\n    --webkit-appearance: textfield;\n}\n\n.PricingHeader_NumberBtns button {\n    /* display: flex;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    width: 22px;\n    height: 22px;\n    padding: 10px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: #d3dde2;\n    border-radius: 40px; */\n    width: 24px;\n    height: 24px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
